import { useEffect } from 'react';
import { funnelProductFromElement, recordFirstPartyFunnel } from '@/lib/firstPartyFunnel';

const FirstPartyFunnelTelemetry = () => {
  useEffect(() => {
    const handleClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const element = event.target.closest('button, a');
      if (!element || element.matches(':disabled, [aria-disabled="true"]')) return;
      const product = funnelProductFromElement(element);
      if (String(element.dataset.funnelStage || '') === 'product_purchase_clicked') {
        recordFirstPartyFunnel('product_purchase_clicked', product);
        window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
          if (document.querySelector('[data-ga-location$="_payment_dialog"]')) {
            recordFirstPartyFunnel('payment_modal_opened', product);
          }
        }));
        return;
      }
      // Provider selection is recorded only by the authoritative backend after
      // it has validated the requested SKU and checkout contract.
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
  return null;
};

export default FirstPartyFunnelTelemetry;
